import axios from 'axios';

let url = '';

export const initReportsService = (config: Record<string, any>) => {
    url = config.reportsURL;
};

export const postNewReport = (payload: {
    type: string;
    properties: RecursivePartial<ProcessedNewMerchantReportFormValues>;
}) => {
    return axios.post(`${url}`, payload);
};

export const postNewReportCSV = (payload: {
    type: string;
    properties: RecursivePartial<ProcessedNewMerchantReportFormValues>;
}) => {
    return axios.post(`${url}/csv`, payload);
};

export const getAllReports = (type: ReportType) => {
    return axios.get(`${url}/all`, {
        params: {
            type
        }
    });
};

export const getSingleReport = async (rid: number) => {
    const res = await axios.get(`${url}/${rid}`);
    return res.data;
};

export const deleteSingleReport = (rid: number) => {
    return axios.delete(`${url}/${rid}`);
};

export const postMarkReportAsRead = (rid: number) => {
    return axios.post(`${url}/${rid}/mark-as-read`);
};
